import React from "react";

const FormProfile = ({ rowData }) => {
  return (
    <div className="lead-profile-info">
      <div className="profile-top">
        <h3 className="lead-name">{rowData?.name || "NA"}</h3>
      </div>

      <div className="lead-other-info">
        <div className="icon-label">
          <span className="label semi-bold">{rowData?.mobile || "NA"}</span>
        </div>

        {rowData?.email ? (
          <div className="icon-label">
            <span className="label email">{rowData?.email || "NA"}</span>
          </div>
        ) : null}

        <div className="icon-label">
          <span className="label">{rowData?.gym_name || "NA"}</span>
        </div>
      </div>
    </div>
  );
};

export default FormProfile;
